import * as jQuery from 'jquery';
import 'jquery-colorbox';

const offerInquiry = () => {
	jQuery('a[href*="investors/offer-inquiry.html?offerId="]').colorbox({
		transition: 'fade',
		opacity: .75,
		maxWidth: '80%',
		maxHeight: '80%',
		fixed: true,
		close: '<span>Close</span>',
		href: function(){
			return jQuery(this).attr('href') + ' #offerInquiryFormWrapper';
		},
		onComplete: function(){
			jQuery.colorbox.resize();
			window.setInterval(function(){
				jQuery.colorbox.resize();
			}, 500);
		}
	});
};

export default offerInquiry;
